//文字コードはutf-8

// スクロールバーの幅を取得してCSS変数に設定
export function setScrollbarWidth() {
  // スクロールバーの幅を取得する関数
  const getScrollbarWidth = () => {
    // 一時的な要素を作成してスクロールバーの幅を測定
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar'; // IE用
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    // スクロールバーの幅 = 外側の幅 - 内側の幅
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // 一時的な要素を削除
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  };

  // スクロールバーの幅を取得してCSS変数に設定
  const updateScrollbarWidth = () => {
    const width = getScrollbarWidth();
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  };

  // 初回実行
  updateScrollbarWidth();

  // リサイズ時にも更新（スクロールバーの表示/非表示が変わる可能性があるため）
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateScrollbarWidth, 100);
  });
}

